export const CONSTANTS = {
  BASE_URL: "https://lp-api.holdstation.com",
};

export function request(path: string, opt?: RequestInit) {
  let url = path;
  if (!url.startsWith("http")) {
    url = `${CONSTANTS.BASE_URL}${path}`;
  }
  return fetch(url, opt);
}
